import { Bug, Lightbulb, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';
import { BugReportModal } from './BugReportModal';
import { FeatureRequestModal } from './FeatureRequestModal';

export function FeedbackButton() {
  const [showMenu, setShowMenu] = useState(false);
  const [featureModalOpen, setFeatureModalOpen] = useState(false);
  const [bugModalOpen, setBugModalOpen] = useState(false);

  useEffect(() => {
    // Listen for custom events from the app
    const handleFeatureRequest = () => {
      setShowMenu(false);
      setFeatureModalOpen(true);
    };
    const handleBugReport = () => {
      setShowMenu(false);
      setBugModalOpen(true);
    };

    window.addEventListener('app:open-feature-request', handleFeatureRequest);
    window.addEventListener('app:open-bug-report', handleBugReport);

    return () => {
      window.removeEventListener('app:open-feature-request', handleFeatureRequest);
      window.removeEventListener('app:open-bug-report', handleBugReport);
    };
  }, []);

  return (
    <>
      {/* Button */}
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="fixed bottom-6 left-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white text-indigo-600 shadow-lg transition-all hover:scale-110 hover:bg-gray-50 lg:left-[260px]"
        title="Feedback"
      >
        {showMenu ? <X className="w-5 h-5" /> : <Lightbulb className="w-5 h-5" />}
      </button>

      {/* Menu */}
      {showMenu && (
        <div className="fixed bottom-[5rem] left-6 z-50 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg lg:left-[260px]">
          <Button
            variant="secondary"
            onClick={() => {
              setShowMenu(false);
              setFeatureModalOpen(true);
            }}
            className="w-full px-4 py-3 text-left text-sm font-medium text-gray-700 hover: flex items-center gap-2 transition-colors border-b border-gray-100"
          >
            <Lightbulb className="w-4 h-4 text-indigo-600" />
            Request Feature
          </Button>
          <button
            onClick={() => {
              setShowMenu(false);
              setBugModalOpen(true);
            }}
            className="w-full px-4 py-3 text-left text-sm font-medium text-gray-700 hover:bg-red-50 flex items-center gap-2 transition-colors"
          >
            <Bug className="w-4 h-4 text-red-600" />
            Report Bug
          </button>
        </div>
      )}

      {/* Modals */}
      <FeatureRequestModal open={featureModalOpen} onClose={() => setFeatureModalOpen(false)} />
      <BugReportModal open={bugModalOpen} onClose={() => setBugModalOpen(false)} />
    </>
  );
}
